import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-collection',
  templateUrl: './payment-collection.component.html',
  styleUrls: ['./payment-collection.component.sass']
})
export class PaymentCollectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
